import { useContext } from 'react';
import ApiContext from 'App/api/ApiContext';

export const useApi = () => {
  return useContext(ApiContext);
};
